<template>
  <div class="loader-container">
    <div class="spinner"></div>
    <!-- <div class="loading-text">Loading...</div> -->
  </div>
</template>

<script setup>
import { onMounted, defineProps, defineEmits } from "vue";

// Define props to receive and pass along the query parameter
const props = defineProps({
  query: {
    type: String,
    default: ''
  }
});

// Define emits for navigation
const emit = defineEmits(['navigate']);

onMounted(() => {
  // Simulate loading time (3 seconds) then navigate to IndexView
  setTimeout(() => {
    emit('navigate', {
      component: 'IndexView',
      query: props.query
    });
  }, 3000);
});
</script>

<style scoped>
.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #026FC2;
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 20px;
}


@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>